export const KILL_INITIATION_MIN_BULLETS = 1;
export const KILL_INITIATION_MAX_MESSAGE_LENGTH = 150;

/** Matches MafiaKillInitiator.AttackResult */
export enum KillAttackResult {
  Attempted = 0,
  BulletAmountOutOfRange = 1,
  VictimInSafehouse = 2,
  VictimInactive = 3,
  RankDifferenceOutOfRange = 4,
  CityMismatch = 5,
  DetectiveLockExpired = 6,
  NoWeaponEquipped = 7,
}
